import { EffectDef, makeGain } from './types';

/** WaveShaper distortion with drive + dry/wet blend. */
export const distortion: EffectDef = {
  type: 'distortion',
  name: 'Distortion',
  params: [
    { key: 'drive', label: 'Drive', min: 1, max: 50, default: 12, step: 1 },
    { key: 'wet', label: 'Wet', min: 0, max: 1, default: 0.7, step: 0.01 },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const dry = makeGain(ctx, 1 - p.wet);
    const wetIn = makeGain(ctx, 1);
    const shaper = ctx.createWaveShaper();
    shaper.oversample = '4x';
    const makeup = makeGain(ctx, 1);
    const wetOut = makeGain(ctx, p.wet);

    input.connect(dry);
    dry.connect(output);
    input.connect(wetIn);
    wetIn.connect(shaper);
    shaper.connect(makeup);
    makeup.connect(wetOut);
    wetOut.connect(output);

    const apply = (params: Record<string, number>) => {
      shaper.curve = makeCurve(params.drive);
      dry.gain.value = 1 - params.wet;
      wetOut.gain.value = params.wet;
      // Compensate for the shaper's compression.
      makeup.gain.value = 1 / Math.sqrt(params.drive);
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        shaper.disconnect();
        dry.disconnect();
        wetIn.disconnect();
        makeup.disconnect();
        wetOut.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};

function makeCurve(drive: number): Float32Array<ArrayBuffer> {
  const n = 1024;
  const curve = new Float32Array(n);
  const k = drive;
  for (let i = 0; i < n; i++) {
    const x = (i * 2) / n - 1;
    curve[i] = ((1 + k) * x) / (1 + k * Math.abs(x));
  }
  return curve;
}